/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {AbstractExtractConf} from './abstractExtractConf';
import {AddField} from './addField';
import {FilterConf} from './filterConf';
import {FtpClient} from './ftpClient';
import {GroupConf} from './groupConf';
import {S3ClientWithName} from './s3ClientWithName';

// FtpExtractConf ==> SharedFileExtractConf
export interface SharedFileExtractConf extends AbstractExtractConf {
    addFields?: Array<AddField>;
    confFtp?: FtpClient;
    confS3Client?: S3ClientWithName;
    connectionId?: string;
    cron?: string;
    enableSchedule?: boolean;
    fileName?: string;
    filtersExtract?: Array<FilterConf>;
    group?: GroupConf;
    patternFileNameWithDate?: boolean;
    scriptPostMapping?: string;
    typeImport?: SharedFileExtractConf.TypeImportEnum;
    typeObject?: string;
    moveFile: boolean;
    targetDirectory?: string;
}

export namespace SharedFileExtractConf {
    export type TypeImportEnum = 'ADD' | 'UPDATE';
    export const TypeImportEnum = {
        ADD: 'ADD' as TypeImportEnum,
        UPDATE: 'UPDATE' as TypeImportEnum
    };
}
